module.exports = __webpack_public_path__ + "static/media/aisan.8f5abec8.png";